import { AxiosResponse } from "axios";

/** Скачивает blob-ответ как файл; имя берёт из Content-Disposition (filename*=UTF-8''… или filename=…), иначе fallback. */
export function downloadBlob(response: AxiosResponse<Blob>, fallbackName: string): void {
  const disposition: string = response.headers?.["content-disposition"] ?? "";
  let fileName = fallbackName;
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  if (utf8) {
    fileName = decodeURIComponent(utf8[1]);
  } else if (plain) {
    fileName = plain[1];
  }
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(response.data);
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(link.href);
}
